module.exports = __webpack_public_path__ + "static/me-7a4a87d9e1d22ddd853ab2f6690c5394.jpg";